import * as React from 'react';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
/** @hidden */
export var RecurrenceFrequencyEditor = function (props) {
    var frequency = props.frequency, frequencies = props.frequencies, onFrequencyChange = props.onFrequencyChange, title = props.title, titleClassName = props.titleClassName, editorClassName = props.editorClassName;
    var onClick = React.useCallback(function (e) { return onFrequencyChange(e.target.dataset.key); }, [onFrequencyChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: titleClassName },
            React.createElement("label", null, title)),
        React.createElement("div", { className: editorClassName },
            React.createElement(ButtonGroup, { width: 'auto' }, frequencies.map(function (freq) {
                return (React.createElement(Button, { key: freq.value, selected: freq.value === frequency, onClick: onClick, "data-key": freq.value, togglable: true }, freq.text));
            })))));
};
//# sourceMappingURL=RecurrenceFrequencyEditor.js.map